import React from 'react';
import { useAppContext } from '@/context/AppContext';
import SectionTitle from '@/components/SectionTitle';
import CheckboxGroup from '@/components/CheckboxGroup';

const featureOptions = [
  { value: 'responsiveDesign', label: 'Responsive Design' },
  { value: 'animations', label: 'Animations' },
  { value: 'darkMode', label: 'Dark Mode' },
  { value: 'auth', label: 'Authentication' },
  { value: 'search', label: 'Search' },
  { value: 'realTime', label: 'Real-time Updates' },
];

const pageOptions = [
  { value: 'landing', label: 'Landing Page' },
  { value: 'about', label: 'About Us' },
  { value: 'contact', label: 'Contact Page' },
  { value: 'privacy', label: 'Privacy Policy' },
  { value: 'terms', label: 'Terms of Service' },
];

function Step4FeaturesPages() {
  const { projectDraft, dispatch } = useAppContext();

  const handleFeatureChange = (selectedValues) => {
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { features: selectedValues } });
  };
  
  const handlePageChange = (selectedValues) => {
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { pages: selectedValues } });
  };

  return (
    <div>
      <SectionTitle title="Step 4: Features & Pages" subtitle="Select the features and pages to include." />
      <div className="space-y-6">
        <div>
          <h3 className="font-medium text-gray-800 mb-2">Core Features</h3>
          <CheckboxGroup
            options={featureOptions}
            selectedValues={projectDraft.features || []}
            onChange={handleFeatureChange}
          />
        </div>
        <div>
          <h3 className="font-medium text-gray-800 mb-2">Standard Pages</h3>
          <CheckboxGroup
            options={pageOptions}
            selectedValues={projectDraft.pages || []}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}

export default Step4FeaturesPages;